import { useFormContext } from "react-hook-form";
import { t } from "@/i18n-js/instance";
import { Form } from "@/react/components/shared/uikit/Form";
import { Button } from "@circle-react-uikit/Button";
import { Modal } from "@circle-react-uikit/ModalV2";

interface FormData {
  otpCode: string;
}

interface OtpChallengeFormContentProps {
  error?: string | null;
  isLoading: boolean;
  isSubmitting: boolean;
  onClose: () => void;
}

export const OtpChallengeFormContent = ({
  error,
  isLoading,
  isSubmitting,
  onClose,
}: OtpChallengeFormContentProps) => {
  const { formState, reset } = useFormContext<FormData>();

  const handleClose = () => {
    reset();
    onClose();
  };

  return (
    <>
      <Modal.Body>
        <div className="space-y-4">
          <p className="text-dark">{t("otp_challenge_modal.description")}</p>

          <Form.Item
            name="otpCode"
            hideDescription
            hideBorder
            label={t("otp_challenge_modal.otp_label")}
            className="!mt-0"
            placeholder={t("otp_challenge_modal.otp_placeholder")}
          >
            <Form.Input
              className="form-control !text-center tracking-widest"
              name="otpCode"
              error={formState.errors.otpCode?.message || error}
              hasError={formState.errors.otpCode?.message || error}
              autoComplete="one-time-code"
              inputMode="numeric"
              pattern="[0-9]*"
              maxLength={6}
            />
            <p className="text-dark mt-4">
              {t("otp_challenge_modal.check_email")}
            </p>

            <p className="mt-4 text-sm text-gray-600">
              {t("otp_challenge_modal.experiencing_issues.pre_text")}&nbsp;
              <a
                href={t("otp_challenge_modal.experiencing_issues.link")}
                target="_blank"
                rel="noreferrer"
              >
                {t("otp_challenge_modal.experiencing_issues.link_text")}
              </a>
            </p>
          </Form.Item>
        </div>
      </Modal.Body>

      <Modal.Footer className="flex justify-end space-x-3">
        <Button
          type="button"
          variant="secondary"
          onClick={handleClose}
          disabled={isSubmitting || isLoading}
        >
          {t("cancel")}
        </Button>
        <Button
          type="submit"
          variant="primary"
          disabled={isSubmitting || isLoading}
        >
          {t("otp_challenge_modal.verify")}
        </Button>
      </Modal.Footer>
    </>
  );
};

OtpChallengeFormContent.displayName = "OtpChallengeFormContent";
